<app-warning-modal />

<!-- VERSÃO MOBILE -->
<div class="lg:hidden min-h-screen-safe relative flex flex-col">
  <!-- Imagem de fundo fullscreen -->
  <div class="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style="background-image: url('assets/img/LandingPage-1.png');"></div>

  <!-- Overlay escuro -->
  <div class="absolute inset-0 bg-black/40"></div>

  <!-- Conteúdo Mobile -->
  <div class="relative z-10 flex-1 flex flex-col justify-center items-center px-6 py-12 safe-area-inset">

    <!-- Card branco -->
    <div class="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">

      <!-- Logo -->
      <div class="mb-8 cursor-pointer" (click)="navigateToLanding()">
        <img src="assets/icons/logo-v2.svg" class="h-6 max-w-[200px]" />
      </div>

      <!-- Título -->
      <div class="mb-2">
        <h1 class="text-2xl font-semibold text-neutral-900">
          Esqueci minha senha
        </h1>
      </div>

      <!-- Descrição -->
      <p class="text-sm text-neutral-600 mb-8">
        Digite seu e-mail e enviaremos um código de verificação para redefinir sua senha.
      </p>

      <!-- Formulário -->
      <form class="space-y-5" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit($event)">
        <!-- Campo Email -->
        <div>
          <label for="email-mobile" class="block text-sm font-medium text-neutral-900 mb-2">
            Email
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <input formControlName="email" id="email-mobile" name="email" type="email" autocomplete="email"
              placeholder="email@domain.com"
              class="block w-full pl-10 pr-4 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white">
          </div>
        </div>

        <!-- Botão de Submit -->
        <button type="submit" [disabled]="forgotPasswordForm.invalid || loading" class="w-full py-3.5 px-4 rounded-full font-medium text-white transition-all duration-200 flex items-center justify-center gap-2
                 bg-neutral-900 hover:bg-neutral-800 
                 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2
                 disabled:bg-neutral-300 disabled:cursor-not-allowed">
          <app-loading-spinner *ngIf="loading" size="sm"></app-loading-spinner>
          {{ loading ? 'Enviando...' : 'Enviar código' }}
        </button>
      </form>

      <!-- Link para voltar ao login -->
      <div class="mt-6 text-center">
        <a (click)="navigateToLogin()" class="text-sm text-neutral-600 hover:text-neutral-900 underline transition-colors cursor-pointer">
          Voltar para o login
        </a>
      </div>
    </div>
  </div>
</div>

<!-- VERSÃO DESKTOP - Layout Split -->
<div class="hidden lg:flex min-h-screen flex-row">
  <!-- Lado Esquerdo - Formulário -->
  <div class="flex-1 flex flex-col justify-center items-center bg-[#efeee9]">
    <div class="w-full max-w-md flex-col gap-4 flex">
      <!-- Logo -->
      <div class="cursor-pointer" (click)="navigateToLanding()">
        <img src="assets/icons/logo-v2.svg" class="h-6 max-w-[200px]" />
      </div>
      <!-- Título -->
      <h1 class="text-3xl font-bold text-neutral-900">
        Esqueci minha senha
      </h1>

      <!-- Descrição -->
      <p class="text-sm text-neutral-600">
        Digite seu e-mail e enviaremos um código de verificação para redefinir sua senha.
      </p>

      <!-- Formulário -->
      <form class="space-y-6" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit($event)">
        <!-- Campo Email -->
        <div>
          <label for="email" class="block text-sm font-medium text-neutral-900 mb-2">
            Email
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <input formControlName="email" id="email" name="email" type="email" autocomplete="email"
              placeholder="email@domain.com"
              class="block w-full pl-10 pr-4 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200">
          </div>
        </div>

        <!-- Botão de Submit -->
        <button type="submit" [disabled]="forgotPasswordForm.invalid || loading" class="w-full py-3.5 px-4 rounded-full font-medium text-white transition-all duration-200 flex items-center justify-center gap-2
                 bg-neutral-900 hover:bg-neutral-800 
                 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2
                 disabled:bg-neutral-300 disabled:cursor-not-allowed">
          <app-loading-spinner *ngIf="loading" size="sm"></app-loading-spinner>
          {{ loading ? 'Enviando...' : 'Enviar código' }}
        </button>
      </form>

      <!-- Link para voltar ao login -->
      <div class="mt-2">
        <a (click)="navigateToLogin()" class="text-sm text-neutral-600 hover:text-neutral-900 underline transition-colors cursor-pointer">
          Voltar para o login
        </a>
      </div>
    </div>
  </div>

  <!-- Lado Direito - Imagem -->
  <div class="flex-1 relative overflow-hidden">
    <!-- Imagem de fundo -->
    <div class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style="background-image: url('assets/img/LandingPage-1.png');"></div>

    <!-- Overlay escuro sutil -->
    <div class="absolute inset-0 bg-black/20"></div>

    <!-- Conteúdo sobre a imagem -->
    <div class="relative z-10 flex flex-col justify-end items-start p-12 xl:p-16 pb-20 w-full h-full">
      <!-- Texto de boas-vindas -->
      <h2 class="text-5xl xl:text-6xl font-bold text-white mb-4">
        Recuperar acesso
      </h2>
      <p class="text-white/90 text-base max-w-md leading-relaxed">
        Não se preocupe, vamos te ajudar a recuperar o acesso à sua conta.
      </p>
    </div>
  </div>
</div>
